export default [
    // {
    //     value: 'shop',
    //     label: 'All Shops',
    // },
{
    value:'Essential Goods & Food',
    label:'Essential Goods & Food',
    
    children: [{
        value:'Vegetables & Fruits',
        label:'Vegetables & Fruits'
    },{
        value: 'Supermarket',
        label: 'Supermarket'
    },{
        value:'Grocery',
        label:'Grocery'
    },{
        value:'Food / Restaurants',
        label:'Food / Restaurants'
    },{
        value:'Agri Products',
        label:'Agri Products'
    }]
},
{
value: 'Fashion',
label: 'Fashion',
         
    children: [{
    value: 'Clothing',
    label: 'Clothing'
},{
    value: 'Health & Beauty',
    label: 'Health & Beauty'
},{
    value: 'Jewelry & Watches',
    label: 'Jewelry & Watches'
            
},{
    value: 'Diamonds & Gems',
    label: 'Diamonds & Gems'
},{
    value: 'Fancy Items',
    label: 'Fancy Items'
},{
    value: 'Baby Kids & Toys',
    label: 'Baby Kids & Toys'
},{
    value: 'Shoes & Footwear',
    label: 'Shoes & Footwear'
},{
    value: 'Bags',
    label: 'Bags'                       
}]
},{
  value: 'Mobiles & Tablets',
  label: 'Mobiles & Tablets',
},{
  value: 'Computers',
  label: 'Computers',
},{
  value: 'Vehicles',
  label: 'Vehicles',

  children: [
    {
        value: 'Vehicles',
        label: 'Vehicles' 
    },
    {
    value: 'Auto Parts',
    label: 'Auto Parts'
    }
  

]
},{
    value: 'Electronics',
    label: 'Electronics'
},{
  value: 'Home Appliances',
  label: 'Home Appliances',

    children: [{
    value: 'Household Supplies',
    label: 'Household Supplies'
},{
    value: 'Tiles & Bathware',
    label: 'Tiles & Bathware'
},{
    value: 'Lighting & Electrical',
    label: 'Lighting & Electrical'
},{
    value: 'Outdoor',
    label: 'Outdoor' 
}]
},{
    value: 'Furniture',
    label: 'Furniture',
 },{
    value: 'Cameras',
    label: 'Cameras',
  },{
  value: 'Home Decor',
  label: 'Home Decor',
  
  children: [{
    value: 'Home Decoration',
    label: 'Home Decoration'
},{
    value: 'Window Treatments',
    label: 'Window Treatments'
},{
   value: 'Handicrafts',
   label: 'Handicrafts',
}]
},{
   value: 'Tools & Machines',
   label: 'Tools & Machines',
},{
    value: 'Books',
    label: 'Books',
 },{
   value: 'Sports',
   label: 'Sports',
},{
   value: 'Music',
   label: 'Music',
},
]


// WEBPACK FOOTER //
// ./src/data/maincategories.js